import { useEffect, useRef, useState } from 'react';
import { setGlobalNotificationListener } from '../../utils/globalNotifier';

/**
 * Mounted once at the app root. Shows toasts triggered from outside the React tree —
 * currently used by the axios response interceptor for API access-denied errors — so
 * every page gets consistent handling without each one wiring its own catch block for it.
 */
export default function GlobalNotificationBar() {
  const [notification, setNotification] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    setGlobalNotificationListener((message, type) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      setNotification({ message, type });
      timerRef.current = setTimeout(() => setNotification(null), 4000);
    });
    return () => setGlobalNotificationListener(null);
  }, []);

  if (!notification) return null;
  return (
    <div className={`notification notification-${notification.type}`}>
      <span>{notification.type === 'success' ? '✓' : '✕'}</span>
      {notification.message}
    </div>
  );
}
